<div class="row ss-top-menu">
	<div class="col-sm-12">
		<span class="ss-text-dark"  style="vertical-align: -webkit-baseline-middle;">Dashboard <i class="rightArrow fa fa-angle-right"></i></span>
		<span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Global Configuration Presets</span>
	</div>
</div>

<div class="rk-ui-notification" *ngIf="successalert">
	<span id="notificationMessageText">{{successMessage}}</span>
	<a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
	<span id="notificationMessageText">{{errorMessage}}</span>
	<a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="text-right"><button class="rk-interalBtnColor addCursor mt-3" data-toggle="modal" data-target="#presetModal" (click)="updatemodal_bool=false">Add Preset</button></div>

<div id="navcontainer">
  <ul class="nav nav-tabs tabs-chng" id="myTab" role="tablist">
    <li class="nav-item nav-items">
      <a class="nav-link addCursor text-center mr-3" [ngClass]="{'active': selectedTab == 'kitchen'}" (click)="changeSelectedTab('kitchen')">Kitchen</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link addCursor text-center mr-3" [ngClass]="{'active': selectedTab == 'wardrobe'}" (click)="changeSelectedTab('wardrobe')">Wardrobe</a>
    </li>
  </ul>
</div>

<div class="container-set">
	<div class="row">
		<div class="col-md-12">
			<div class="tableDiv table-responsive">
				<div class="col-md-12" *ngIf="preset_list &&  preset_list.length==0 ">
		      <div class="boq-img text-center">
		        <img src="assets/img/desktop.png" style="height: 250px;width: 300px">
		      </div>
		      <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
		    </div>
				<!-- <p class="text-center mt-5" *ngIf="preset_list &&  preset_list.length==0 ">No Presets</p> -->
				<div class='paginated_container' ng-controller='PaginatedUserListCtrl'>
					<table class="table px-3 py-3" *ngIf="preset_list &&  preset_list.length>0" >
						<thead>
							<tr>
								<th class="text-center firstTh">#</th>
								<th>Name</th>
								<th>Created By</th>
								<th class="minWidthForTd">Date</th>
								<th class="minWidthForTd">Remarks</th>
								<th class="lastTh"></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let data of preset_list | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } let i = index; " [attr.data-index]="i" id="presetListRow{{i}}">
								<td class="text-center">{{((current_page-1) * per_page) + (i+1)}}</td>
								<td class="capitalize minWidthForTd addCursor" (click)="openEditPresetModal(data)" style="color: #007bff;">{{data.preset_name}}</td>
								<td class="minWidthForTd capitalize">{{data.preset_created_by.name}} - {{data.preset_created_by.email}}</td>
								<td class="minWidthForTd ">{{data.created_at | date:'dd MMM, y , h:mm a'}}</td>
								<td class="minWidthForTd capitalize">{{data.preset_remark}}</td>
								<td>
									<i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                  <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                    <a class="dropdown-item addCursor" (click)="openEditPresetModal(data)">Edit</a>
                    <a class="dropdown-item addCursor" (click)="deletePreset(data.id)">Delete</a>
                  </div>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="text-center" *ngIf="preset_list && preset_list.length >0">
						<pagination-controls autoHide="true" (pageChange)="current_page = getGlobalPresets(selectedTab,$event)"></pagination-controls>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="presetModal" tabindex="-1" role="dialog" aria-labelledby="presetModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title modalTitle" id="presetModalLabel"><ng-container *ngIf="!updatemodal_bool">Create a preset</ng-container><ng-container *ngIf="updatemodal_bool">Update preset</ng-container></h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closePresetModal()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<form [formGroup]="addPresetForm">
					<div class="row">
						<div class="col-sm-12 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Preset Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" formControlName="preset_name">
              </div>
            </div>
						<div class="col-sm-12 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Category <span class="text-danger">*</span></label>
                <select formControlName="category" class="form-control" (change)="getGlobalVariable($event.target.value); onChangeOfCategory($event.target.value,addPresetForm)" [ngClass]="{'d-none':updatemodal_bool}">
									<option value="">Select</option>
									<option value="kitchen">Kitchen</option>
									<option value="wardrobe">Wardrobe</option>
								</select>
								<input type="text" name="" readonly formControlName="category" class="form-control capitalize" [ngClass]="{'d-none':!updatemodal_bool}">
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['category'].value!='kitchen')}">
              <div class="form-group">
                <label class="text-left">Type Of Kitchen <span class="text-danger">*</span></label>
                <select formControlName="civil_kitchen" class="form-control"  (change)="onChangeOfTOK($event.target.value,addPresetForm)">
									<option value="">Select</option>
                  <option value='true'>Civil Kitchen</option>
                  <option value='false'>Modular Kitchen</option>
								</select>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['civil_kitchen'].value!='true' && addPresetForm.controls['civil_kitchen'].value!=true) || (addPresetForm.controls['category'].value!='kitchen')}">
						  <div class="form-group">
						    <label class="text-left">Depth in mm <span class="text-danger">*</span></label>
						    <input type="number" name="" class="form-control" formControlName="depth" min="0"> 
						  </div>
						</div>
            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['civil_kitchen'].value!='true' && addPresetForm.controls['civil_kitchen'].value!=true) || (addPresetForm.controls['category'].value!='kitchen')}">
						  <div class="form-group">
						    <label class="text-left">Drawer 1 Height in mm(D1) <span class="text-danger">*</span></label>
						    <input type="number" name="" class="form-control" formControlName="drawer_height_1" min="130"> 
						  </div>
						</div>
						<div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['civil_kitchen'].value!='true' && addPresetForm.controls['civil_kitchen'].value!=true) || (addPresetForm.controls['category'].value!='kitchen')}">
						  <div class="form-group">
						    <label class="text-left">Drawer 2 Height in mm(D2) <span class="text-danger">*</span></label>
						    <input type="number" name="" class="form-control" formControlName="drawer_height_2" min="150"> 
						  </div>
						</div>
						<div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['civil_kitchen'].value!='true' && addPresetForm.controls['civil_kitchen'].value!=true) || (addPresetForm.controls['category'].value!='kitchen')}">
						  <div class="form-group">
						    <label class="text-left">Drawer 3 Height in mm(D3) <span class="text-danger">*</span></label>
						    <input type="number" name="" class="form-control" formControlName="drawer_height_3" min="360"> 
						  </div>
						</div>
            <ng-container *ngIf="globalVarArr_dropdown_data_dropdown_data">
	            <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	                <label class="text-left">Core Material <span class="text-danger">*</span></label>
	                <select formControlName="core_material" class="form-control">
										<option value="">Select</option>
										<option *ngFor="let coremat of globalVarArr_dropdown_data_dropdown_data.core_material" value="{{coremat.name}}">{{coremat.name}}</option>
									</select>
	              </div>
	            </div>
	            <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	                <label class="text-left">Shutter Material <span class="text-danger">*</span></label>
	                <select class="form-control" formControlName="shutter_material" (change)="listofShutterFinishes($event.target.value,addPresetForm)">
										<option value="">Select</option>
										<option *ngFor="let shuttermat of globalVarArr_dropdown_data_dropdown_data.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
									</select>
	              </div>
	            </div>
	            <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	                <label class="text-left">Shutter Finish <span class="text-danger">*</span></label>
	                <select class="form-control" formControlName="shutter_finish" (change)="listofShutterFinishShades($event.target.value,addPresetForm);">
										<option value="">Select</option>
										<option *ngFor="let shutter_fin of globalVarArr_dropdown_data_dropdown_data.shutter_finish" value="{{shutter_fin.name}}">{{shutter_fin.name}}</option>
									</select>
	              </div>
	            </div>
	            <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	                <label class="text-left">Shutter Shade Code <span class="text-danger">*</span></label>
	                <a class="addCursor d-block" (click)="openModal('#shadeCodeModal','#presetModal',addPresetForm)">Choose Shade Code</a>
	                <span>{{addPresetForm.controls['shutter_shade_code'].value}}</span>
	                <img src="{{addPresetForm.controls['shutter_shade_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addPresetForm.controls['shutter_shade_code_img'].value " onerror="this.src='./assets/img/no_image.svg'">
	              </div>
	            </div>
	            <!-- <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	                <label class="text-left">Edge Banding Shade <span class="text-danger">*</span></label>
	                <a  class="addCursor d-block" (click)="openModal('#edgebandingShadeModal','#presetModal',addPresetForm)">Choose Edge Banding Shade Code</a>
	                <span>{{addPresetForm.controls['edge_banding_shade_code'].value}}</span>
	                <img src="{{addPresetForm.controls['edge_banding_shade_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addPresetForm.controls['edge_banding_shade_code_img'].value " onerror="this.src='./assets/img/no_image.svg'">
	              </div>
	            </div> -->
	            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['category'].value!='wardrobe')}">
	              <div class="form-group">
	                <label class="text-left">Shutter Handle Code <span class="text-danger">*</span></label>
	                <a class="addCursor d-block" (click)="openModal('#handleCodeModal','#presetModal',addPresetForm); setHandleModalParams('shutter')">Choose Shutter Handle Code</a>
	                <span>{{addPresetForm.controls['shutter_handle_code'].value}}</span>
	                <img src="{{addPresetForm.controls['shutter_handle_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addPresetForm.controls['shutter_handle_code_img'].value " onerror="this.src='./assets/img/no_image.svg'">
	              </div>
	            </div>
	            <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	              	<label class="text-left" [ngClass]="{'d-block': (addPresetForm.controls['category'].value!='wardrobe'),'d-none':(addPresetForm.controls['category'].value=='wardrobe')}">Handle Code <span class="text-danger">*</span></label>
	                <label class="text-left" [ngClass]="{'d-block': (addPresetForm.controls['category'].value=='wardrobe'),'d-none':(addPresetForm.controls['category'].value!='wardrobe')}">Drawer Handle Code <span class="text-danger">*</span></label>
	                <a class="addCursor d-block" (click)="openModal('#handleCodeModal','#presetModal',addPresetForm); setHandleModalParams('door');">Choose Handle Code</a>
	                <span>{{addPresetForm.controls['door_handle_code'].value}}</span>
	                <img src="{{addPresetForm.controls['door_handle_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addPresetForm.controls['door_handle_code_img'].value " onerror="this.src='./assets/img/no_image.svg'">
	              </div>
	            </div>
	            <!-- <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	                <label class="text-left">Hardware Brand <span class="text-danger">*</span></label>
	                <select class="form-control" formControlName="brand_id">
	                  <option value="">Select</option>
	                  <option *ngFor="let hb of globalVarArr_dropdown_data_dropdown_data.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
	                </select>
	              </div>
	            </div> -->
	            <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	                <label class="text-left">Hinge Type <span class="text-danger">*</span></label>
	                <select class="form-control" formControlName="hinge_type">
	                  <option value="">Select</option>
	                  <option *ngFor="let ht of globalVarArr_dropdown_data_dropdown_data.hinge_type" value="{{ht}}">{{ht | uppercase}} <span *ngIf="ht=='soft'"> - CLOSE</span></option>
	                </select>
	              </div>
	            </div>
	            <!-- <div class="col-sm-12 col-md-6 mb-2">
	              <div class="form-group">
	                <label class="text-left">Channel Type <span class="text-danger">*</span></label>
	                <select class="form-control" formControlName="channel_type">
	                  <option value="">Select</option>
	                  <option *ngFor="let ct of globalVarArr_dropdown_data_dropdown_data.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
	                </select>
	              </div>
	            </div> -->
	            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['category'].value!='kitchen')}">
	              <div class="form-group">
	                <label class="text-left">Skirting Config Type<span class="text-danger">*</span></label>
	                <select class="form-control" formControlName="skirting_config_type" (change)="listofSkirtingHeights($event.target.value,addPresetForm)">
	                  <option value="">Select</option>
	                  <option *ngFor="let sct of globalVarArr_dropdown_data_dropdown_data.skirting_config_type" value="{{sct.skirting_type}}">{{sct.skirting_type | uppercase}}</option>
	                </select>
	              </div>
	            </div>
	            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['category'].value!='kitchen')}">
	              <div class="form-group">
	                <label class="text-left"> Skirting Config Height <span class="text-danger">*</span></label>
	                <select class="form-control" formControlName="skirting_config_height">
	                  <option value="">Select</option>
	                  <option *ngFor="let sch of globalVarArr_dropdown_data_dropdown_data.skirting_config_height" value="{{sch.skirting_height}}">{{sch.skirting_height}}</option>
	                </select>
	              </div>
	            </div>
	            <!-- <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addPresetForm.controls['category'].value!='kitchen')}">
	              <div class="form-group">
	                <label class="text-left">Countertop <span class="text-danger">*</span></label>
	                <select class="form-control" formControlName="countertop">
	                  <option value="">Select</option>
	                  <option *ngFor="let count_top of globalVarArr_dropdown_data_dropdown_data.countertop" value="{{count_top}}">{{count_top | replaceChar}}</option>
	                </select>
	              </div>
	            </div> -->
	            <div class="col-sm-12 col-md-6 mb-2" *ngIf="addPresetForm.controls['created_by_name'].value">
	              <div class="form-group">
	                <label class="text-left">Created By</label>
	                <p>{{addPresetForm.controls['created_by_name'].value}}-{{addPresetForm.controls['created_by_email'].value}}</p>
	              </div>
	            </div>
	            <div class="col-sm-12 col-md-6 mb-2" *ngIf="addPresetForm.controls['created_at'].value">
	              <div class="form-group">
	                <label class="text-left">Created At</label>
	                <p>{{addPresetForm.controls['created_at'].value | date:'dd MMM, y , h:mm a'}}</p>
	              </div>
	            </div>
	            <div class="col-sm-12 col-md-12 mb-2">
	              <div class="form-group">
	                <label class="text-left">Remark</label>
	                <textarea rows="2" formControlName="preset_remark" class="form-control"></textarea>
	              </div>
	            </div>
          	</ng-container>
					</div>
					<div>
						<ng-container *ngIf="!updatemodal_bool"><button class="pull-right rk-interalBtnColor mr-2 my-2 addCursor" [disabled]="!addPresetForm.valid" (click)="savePreset(addPresetForm.value)" [ngClass]="{'cursor-notallowed':!addPresetForm.valid, 'addCursor':addPresetForm.valid}">Save</button></ng-container>
						<ng-container *ngIf="updatemodal_bool"><button class="pull-right rk-interalBtnColor mr-2 my-2 addCursor" [disabled]="!addPresetForm.valid" (click)="updatePreset(updatePreset_Obj.id,addPresetForm.value)" [ngClass]="{'cursor-notallowed':!addPresetForm.valid, 'addCursor':addPresetForm.valid}">Update</button></ng-container>
						<button class="pull-right rk-btnCancel my-2 addCursor mr-3" data-dismiss="modal" (click)="closePresetModal()">Cancel</button>
					</div>
					<!-- <pre>{{addPresetForm.value | json}}</pre> -->
				</form>
			</div>
		</div>
	</div>
</div>


<div class="modal fade" id="shadeCodeModal" tabindex="-1" role="dialog" aria-labelledby="shadeCodeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title modalTitle" id="exampleModalLabel">Select Shade Code</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal('#shadeCodeModal',parentModalName)">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body mt-3">
				<div class="row mb-2" *ngIf="globalVarArr_dropdown_data_dropdown_data">
					<div class="col-4"><label>Enter custom shade code</label></div>
					<div class="col-8">
						<input type="text" class="form-control d-inline" placeholder="Enter custom shade code" style="width:54%" [(ngModel)]="customshadecode"><button class="rk-interalBtnColor ml-3 addCursor" (click)="addShadeCode(customshadecode,true)" [disabled]="customshadecode==undefined">Add</button>
					</div>
				</div>
				<div class="">
					<hr class="custom-hr hrTag">
				</div>
				<div class="row" *ngIf="globalVarArr_dropdown_data_dropdown_data">
					<div class="col-sm-2 text-center" *ngFor=" let shadecode of globalVarArr_dropdown_data_dropdown_data.shutter_shade_code">
						<img src="{{shadecode.shade_image}}" (click)="addShadeCode(shadecode,false)" height="75px" style=" max-width: 100px;" *ngIf="shadecode.shade_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
						<p (click)="addShadeCode(shadecode,false)" class="text-center mt-2 addCursor">{{shadecode.code}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="edgebandingShadeModal" tabindex="-1" role="dialog" aria-labelledby="edgebandingShadeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title modalTitle" id="edgebandingShadeModalLabel">Select Edge Banding Shade Code</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal('#edgebandingShadeModal',parentModalName)">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body mt-3">
				<div class="row mb-2" *ngIf="globalVarArr_dropdown_data_dropdown_data">
					<div class="col-4"><label>Enter custom edge banding shade code</label></div>
					<div class="col-8">
						<input type="text" class="form-control d-inline" placeholder="Enter custom edge banding shade code" style="width:60%" [(ngModel)]="customedgebanshadecode"><button class="rk-interalBtnColor ml-3 addCursor" (click)="addEdgeBanShadeCode(customedgebanshadecode,true)"  [disabled]="customedgebanshadecode==undefined">Add</button>
					</div>
				</div>
				<div class="">
					<hr class="custom-hr hrTag">
				</div>
				<div class="row" *ngIf="globalVarArr_dropdown_data_dropdown_data">
					<div class="col-sm-2 text-center" *ngFor=" let edgebandingcode of globalVarArr_dropdown_data_dropdown_data.edge_banding_shade_code">
						<img src="{{edgebandingcode.shade_image}}" (click)="addEdgeBanShadeCode(edgebandingcode,false)" height="75px" style=" max-width: 100px;" *ngIf="edgebandingcode.shade_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
						<p (click)="addEdgeBanShadeCode(edgebandingcode,false)" class="text-center mt-2 addCursor">{{edgebandingcode.code}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<div class="modal fade" id="handleCodeModal" tabindex="-1" role="dialog" aria-labelledby="handleCodeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="handleCodeModalLabel">Select Handle</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal('#handleCodeModal',parentModalName);">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body mt-3">
        <div class="row">
          <div class="col-sm-2 text-center" *ngFor=" let handlecode of handles_arr">
            <img src="{{handlecode.handle_image}}" (click)="addHandleCode(handlecode)" height="75px" style=" max-width: 100px;" *ngIf="handlecode.handle_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
            <p (click)="addHandleCode(handlecode)" class="text-center mt-2 addCursor">{{handlecode.code}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/quotation/globalvarpreset/globalvarpreset.component.html